import {
  Box,
  Container,
  CssBaseline,
  ThemeProvider,
  Typography,
  useMediaQuery,
} from "@mui/material";
import theme from "../../../config/theme";
import Group86 from "../../../assets/Group86.png";

const Section = ({ serial, bgColor, text, imgSrc }) => {
  const isMobile = useMediaQuery((theme) => theme.breakpoints.down("sm"));
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      {isMobile ? (
        <Box>
          {serial === "first" || serial === "third" ? (
            <Box
              sx={{
                backgroundColor: bgColor,
                display: "flex",
                flexDirection: "column",
              }}
            >
              <Box sx={{ marginLeft: "1.25rem" }}>
                <img
                  src={Group86}
                  alt=""
                  style={{
                    objectFit: "contain",
                    height: "0.5625rem",
                    width: "10.375rem",
                    marginTop: "2.5rem",
                  }}
                />

                <Typography
                  variant="h4"
                  sx={{
                    marginTop: "1.25rem",
                    fontWeight: 400,
                    fontSize: "0.75rem",
                    color: "#212121",
                    letterSpacing: "0.0079055rem",
                  }}
                >
                  {text}
                </Typography>
              </Box>

              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                <img
                  src={imgSrc}
                  alt=""
                  style={{
                    objectFit: "contain",
                    height: "7.8125rem",
                    width: "10.375rem",
                    marginTop: "2.5rem",
                    marginBottom: "3.75rem",
                  }}
                />
              </Box>
            </Box>
          ) : (
            <Box
              sx={{
                backgroundColor: bgColor,
                display: "flex",
                flexDirection: "column",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "flex-end",
                }}
              >
                <img
                  src={Group86}
                  alt=""
                  style={{
                    objectFit: "contain",
                    height: "0.625rem",
                    width: "10.375rem",
                    marginTop: "3.75rem",
                    marginRight: "1.25rem",
                    transform: "rotate(180deg)",
                  }}
                />
              </Box>
              <Typography
                variant="h4"
                sx={{
                  marginTop: "1.25rem",
                  marginLeft: "1.25rem",
                  fontWeight: 400,
                  fontSize: "0.75rem",
                  color: "#212121",
                  letterSpacing: "0.0079055rem",
                }}
              >
                {text}
              </Typography>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                <img
                  src={imgSrc}
                  alt=""
                  style={{
                    objectFit: "contain",
                    height: "7.8125rem",
                    width: "10.375rem",
                    marginTop: "2.5rem",
                    marginBottom: "3.75rem",
                  }}
                />
              </Box>
            </Box>
          )}
          {serial === "third" && (
            <Typography
              variant="h4"
              sx={{
                textAlign: "center",
                fontWeight: 700,
                fontSize: "0.75rem",
                color: "#212121",
                letterSpacing: "0.0064561875rem",
                whiteSpace: "pre-line",
                "& span.violet": {
                  color: "#7313B9",
                },
              }}
            >
              Unlock more value by trying out our other products,{"\n"}
              the <span className="violet">benefits are endless!</span>
              {"\n"}
            </Typography>
          )}
        </Box>
      ) : (
        <Box>
          {serial === "first" || serial === "third" ? (
            <Box sx={{ backgroundColor: bgColor }}>
              <Container sx={{ display: "flex" }}>
                <Box
                  sx={{ display: "flex", flex: "1.5", flexDirection: "column" }}
                >
                  <Box
                    sx={{
                      objectFit: "contain",
                      height: "1.25rem",
                      width: "37.5rem",
                      marginTop: "10.3125rem",
                    }}
                  >
                    <img src={Group86} alt="" />
                  </Box>
                  <Box>
                    <Typography
                      variant="h4"
                      sx={{
                        marginTop: "3.0625rem",
                        marginBottom: "15.9375rem",
                        fontWeight: 400,
                        fontSize: "1.5rem",
                        color: "#212121",
                        letterSpacing: "0.015625rem",
                        width: "21rem",
                      }}
                    >
                      {text}
                    </Typography>
                  </Box>
                </Box>
                <Box sx={{ display: "flex", flex: "1" }}>
                  <Box
                    sx={{
                      objectFit: "contain",
                      height: "20rem",
                      width: "26.5rem",
                      marginTop: "7.5rem",
                      marginBottom: "7.5rem",
                    }}
                  >
                    <img src={imgSrc} alt="" />
                  </Box>
                </Box>
              </Container>
            </Box>
          ) : (
            <Box sx={{ backgroundColor: bgColor }}>
              <Container sx={{ display: "flex" }}>
                <Box sx={{ display: "flex", flex: "1.5" }}>
                  <Box
                    sx={{
                      objectFit: "contain",
                      height: "20rem",
                      width: "26.5225rem",
                      marginTop: "7.5rem",
                      marginBottom: "7.5rem",
                    }}
                  >
                    <img src={imgSrc} alt="" />
                  </Box>
                </Box>
                <Box
                  sx={{
                    display: "flex",
                    flex: "1",
                    flexDirection: "column",
                    justifyContent: "center",
                  }}
                >
                  <Box
                    sx={{
                      objectFit: "contain",
                      height: "1.25rem",
                      width: "37.5rem",
                      marginTop: "9.5rem",
                      // marginLeft: "0.9775rem",
                      transform: "rotate(180deg)",
                    }}
                  >
                    <img src={Group86} alt="" />
                  </Box>
                  <Box>
                    <Typography
                      variant="h4"
                      sx={{
                        marginTop: "3.0625rem",
                        marginBottom: "14.25rem",
                        marginLeft: "17.415rem",
                        fontWeight: 400,
                        fontSize: "1.5rem",
                        color: "#212121",
                        letterSpacing: "0.015625rem",
                        width: "21rem",
                      }}
                    >
                      {text}
                    </Typography>
                  </Box>
                </Box>
              </Container>
            </Box>
          )}
          {serial === "third" && (
            <Box>
              <Typography
                variant="h4"
                sx={{
                  textAlign: "center",
                  fontWeight: 700,
                  fontSize: "2rem",
                  color: "#212121",
                  letterSpacing: "0.015625rem",
                  whiteSpace: "pre-line",
                  "& span.violet": {
                    color: "#7313B9",
                  },
                }}
              >
                Unlock more value by trying out our other products,{"\n"}
                the <span className="violet">benefits are endless!</span>
                {"\n"}
              </Typography>
            </Box>
          )}
        </Box>
      )}
    </ThemeProvider>
  );
};

export default Section;
